// extracted by mini-css-extract-plugin
export default {"doubleCardDisplay":"DoubleCardDisplay_doubleCardDisplay__BZHVb","doubleCardDisplayContent":"DoubleCardDisplay_doubleCardDisplayContent__hDXjr"};